import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { AuthInput, AuthButton, Timer, Snackbar } from '../../components/index'
import { AuthApi } from '../../api/auth'
import { Errors } from '../../utilities/error'
import { SetTokenWithExpiry } from '../../utilities/tokenSetting'
const RegisterVerification = () => {
  const router = useHistory()
  const SignUpVerify = async (code) => {
    await AuthApi.codeVerify(code, localStorage.getItem('userMobile'))
      .then((res) => {
        Snackbar({
          title: 'موفق',
          message: 'ثبت نام شما با موفقیت انجام شد',
          type: 'success',
        })
        if (res.data.data.userOtpVerify) {
          SetTokenWithExpiry(
            'token',
            res.data.data.userOtpVerify.token,
            1000 * 60 * 60 * 24 * 7
          )
          router.push('/')
        }
      })
      .catch((err) => {
        Snackbar({
          title: 'نا موفق',
          message: Errors[err.response.data.errors[0].message],
          type: 'danger',
        })
      })
  }

  return (
    <div className='container'>
      <div className='auth'>
        <div className='logo'>
          <Link to='/'>
            <img src='/images/logo.png' alt='logo' />
          </Link>
        </div>
        <div className='form-list'>
          <Formik
            initialValues={{
              code: '',
            }}
            validationSchema={Yup.object({
              code: Yup.string().required('کد ارسالی را وارد کنید'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setTimeout(() => {
                SignUpVerify(values.code)
                setSubmitting(false)
              }, 300)
            }}
          >
            {(props) => (
              <Form>
                <AuthInput
                  placeholder={'کد تایید'}
                  name='code'
                  type='text'
                  icon={<Timer start={2} />}
                />
                <AuthButton title={'تایید کد ارسال'} />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
export default RegisterVerification
